<template>
    <v-chip label :color="backgroundColor" :text-color="color" class="sr-label">
        {{ text }}
        <SrIcon v-if="hasAction" size="xxs" :icon="actionIcon" class="ml-3 clickable" @click="$emit('action')" />
    </v-chip>
</template>

<script>
import { SrIcon } from '../SrIcon';

export default {
    name: 'SrLabel',
    components: {
        SrIcon,
    },
    props: {
        text: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        actionIcon: {
            type: String,
            default: '',
        },
    },
    computed: {
        backgroundColor() {
            return `${this.color}-light`;
        },
        hasAction() {
            return this.actionIcon !== '';
        },
    },
};
</script>
